import React from 'react';
import Bar from './Bar';
import Navigation from './Navigation';
import { isBrowser } from "react-device-detect";

export default function NavBar() {
    const [open, setOpen] = React.useState(true);
    React.useEffect(() => {
        if (isBrowser) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, []);
    const handleDrawerOpen = () => {
        if (open === true) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    };

    return ([
        <Bar handleDrawerOpen={handleDrawerOpen} key="1" />,
        (open &&
            <Navigation key="2" />
        )
    ])
}
